module.exports = __webpack_public_path__ + "static/media/orderDetailsCircle.46437e02.svg";